module.exports = __webpack_public_path__ + "assets/41d607893764a2ddbb2467f03e490506.mp4";